var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 20,
    viewBox: "0 0 139 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2781 1.75684L59.3877 16.7599H63.526L67.4967 5.64622L71.4659 16.7599H75.6064L69.716 1.75684H65.2781Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4296 1.38281C93.6671 1.38281 90.1689 4.47186 90.1689 9.25703C90.1689 14.1125 93.5893 17.1312 98.4296 17.1312C103.27 17.1312 106.69 14.1132 106.69 9.25703C106.69 4.39855 103.27 1.38281 98.4296 1.38281ZM98.4296 13.8032C95.8751 13.8032 94.0906 11.9352 94.0906 9.25703C94.0906 6.57883 95.8751 4.71089 98.4296 4.71089C101.068 4.71089 102.77 6.49559 102.77 9.25703C102.77 11.9742 101.028 13.8032 98.4296 13.8032Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7422 1.75684L41.2773 16.7599H45.704L51.7906 13.1997H46.7872L49.769 5.45224L54.1217 16.7599H58.2607L51.7959 1.75684H47.7422Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9689 1.75684H76.812V16.7599H80.7314V5.06277H82.6654C84.0566 5.06277 85.2765 5.78444 85.2765 7.35913C85.2765 8.93611 84.0566 9.65702 82.6654 9.65702H81.6138L83.3908 12.6666C86.2602 12.6666 89.0238 10.8598 89.0238 7.11399C89.0253 3.37124 86.2941 1.75684 82.9689 1.75684Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.537 1.75684H128.479L122.017 16.7599H126.153L130.509 5.45224L133.491 13.1997H128.485L134.574 16.7599H139L132.537 1.75684Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.071 4.72363C117.445 4.72363 118.82 5.14746 119.867 5.73167L121.151 2.75412C119.668 1.88582 117.816 1.38867 116.128 1.38867C110.822 1.38867 107.996 5.19939 107.996 9.25831C107.996 13.3172 110.822 17.131 116.128 17.131C117.816 17.131 119.668 16.6346 121.151 15.7625L119.867 12.7865C118.82 13.3714 117.445 13.7945 116.071 13.7945C113.96 13.7945 111.928 12.0213 111.928 9.25907C111.928 6.49611 113.96 4.72363 116.071 4.72363Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55889 0L0 5.00052H17.1193L8.55889 0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9982L8.55889 20.0002L0 5.00098V14.9982Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1195 15.0013V5.00098L8.55908 20.0002L17.1195 15.0013Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6795 19.9991L17.1191 14.9971H34.2414L25.6795 19.9991Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1191 5.00052L25.6795 0L17.1191 14.9977V5.00052Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2416 4.99823V14.9977L25.6797 0L34.2416 4.99823Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2085aeba7c3877eaede07b9be989d62f.svg";
export { ForwardRef as ReactComponent };